import React, { FC } from 'react';
import { media } from 'src/styles/designs';
import styled from 'styled-components';
import { useTranslate } from 'react-t7e';
import { ConstraintContainer } from 'src/components/common/ConstraintContainer';
import { Markdown } from 'vendor/mods/markdown/components/Markdown';

const Paragraph = styled.p`
  font-size: 14px;
  font-weight: 300;
  line-height: 21px;
  margin-bottom: 8px;
  max-width: 900px;
`;

const Container = styled(ConstraintContainer)`
  padding-top: 50px;

  ${media.w.greaterThanOrEqual.desktop} {
    padding-top: 90px;
  }
`;

const InnerContainer = styled.div`
  padding-top: 20px;
  border-top: 1rpx solid #d6d6d6;
  ${media.w.greaterThanOrEqual.desktop} {
    padding-top: 30px;
  }
`;

export const ProductsLegalMentions: FC = () => {
  const { _ } = useTranslate();

  return (
    <Container>
      <InnerContainer>
        <Paragraph>
          *
          {_(
            'These class III medical devices are regulated health products which bear, under this regulation, the CE marking. Manufacturer: MATEX LAB SPA, 2 via Carlo Urbani Brindisi, Italy. Please carefully read the instructions in the leaflets. The use of these products requires the intervention of a healthcare professional.',
          )}
        </Paragraph>
        <Paragraph>
          **
          {_(
            'These class: IIb for Sectum, IIa for Zaffiro, IIb for Plasma IQ, Medical Devices are regulated health products which bear, under this regulation, the CE mark. Manufacturer: B&K, Domaniewska 37, Warsaw, Poland. Please carefully read the instructions in the leaflets. The use of these products requires the intervention of a healthcare professional.',
          )}
        </Paragraph>
        <Paragraph>
          ***
          <Markdown>
            {_(
              'Neauvia Cosmeceuticals are cosmetic products according to Regulation 1223/2009',
            )}
          </Markdown>
        </Paragraph>
      </InnerContainer>
    </Container>
  );
};
